import styled from 'styled-components'
import { Flex, Box, Text, getPaletteColor } from 'pcln-design-system'

const PhoneSalesBannerContainer = styled(Flex)`
  border: solid ${getPaletteColor('border.base')} 1px;
  border-radius: ${(props) => props?.theme?.borderRadii?.xl};
  align-items: center;
`

const IconContainer = styled(Flex)`
  align-self: stretch;
  border-radius: ${(props) => props?.theme?.borderRadii?.xl};
`

const ThoughtBubble = styled(Text)`
  border-radius: 2px 2px 2px 0px;
`

const PhoneDealsText = styled(Text)`
  white-space: nowrap;
`

const Arrow = styled(Box)`
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 4px 4px 0 0;
  border-color: ${getPaletteColor('background.lightest')} transparent transparent transparent;
`

const PhoneLink = styled.a`
  text-decoration: none;
  color: ${getPaletteColor('primary.base')};
`

const MobilePhoneLinkWrapper = styled.a`
  text-decoration: none;
`

const AltPhoneLink = styled.a`
  text-decoration: none;
  font-size: 13px;
  font-weight: bold;
  color: ${getPaletteColor('primary.base')};
`

const StyledResponsiveImg = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  box-shadow: 0 0 0px 1px ${getPaletteColor('border.base')};
  margin: 8px;
`

export {
  PhoneSalesBannerContainer,
  IconContainer,
  Arrow,
  ThoughtBubble,
  PhoneLink,
  StyledResponsiveImg,
  PhoneDealsText,
  AltPhoneLink,
  MobilePhoneLinkWrapper,
}